<template>
    <select v-model="selected" :class="cssClass" @change="change()" :disabled="disabled">
        <option value v-if="blankOption">{{ blankOption }}</option>
        <option v-for="option in options" :value="option.value" :selected="isSelected(option.value)">
            {{ option.name }}
        </option>
    </select>
</template>
<script>
    export default {
        props: {
            options: {
                type: Array,
                required: true,
            },
            selectedOption: {
                type: [Number, String],
                default: '',
            },
            baseUrl: {
                type: String,
                required: true,
            },
            blankOption: {
                type: String,
                default: '',
            },
            cssClass: {
                type: [Object, String],
                required: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                selected: this.selectedOption,
            };
        },
        mounted() {
            if (this.blankOption === '' && this.selected === '') {
                this.selected = this.options[0].value;
            }
            this.$emit('input', this.selected);
        },
        methods: {
            isSelected(value) {
                return this.selected.toString() === value.toString();
            },
            change() {
                this.$emit('input', this.selected);
                window.location.href = this.baseUrl + this.selected;
            },
        },
    };
</script>
